const AnimationContent = ({content}) => {
    return ( <>{content && <div className="__body">{content}</div>}</> );
}
 
export default AnimationContent;